import { render, staticRenderFns } from "./ProductTabContent.vue?vue&type=template&id=693956f2&"
import script from "./ProductTabContent.vue?vue&type=script&lang=js&"
export * from "./ProductTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports